// hide options SET configurator
window.addEventListener("Angle3DCustomizerLoaded", function(event) {
  let confOptions = '';
  const settingsJSON = document.querySelector('.configurator__settings #option-settings');
  if (!settingsJSON) return;
  const confSettingsOptions = JSON.parse(settingsJSON.textContent);
  let selectors = '';
  if (window.innerWidth > 575) {
    selectors = {
      "option": ".tda-customizer-customization-option",
      "title": ".tda-customizer-customization-option-title",
      "option_item": ".tda-customizer-customization-option-value",
      "value_title": ".tda-customizer-customization-option-value-title",
      "value_selected": "tda-customizer-customization-option-value-selected"
    }
  } else {
    selectors = {
      "option": ".tda-customizer-customization-options-container .option__item",
      "title": ".tda-customizer-customization-options-container .option__item_title",
      "option_item": ".tda-customizer-customization-options-container .option__item .tda-customizer-customization-option-value",
      "value_title": ".tda-customizer-customization-options-container .option__item .tda-customizer-customization-option-value-title",
      "value_selected": "tda-customizer-customization-option-value-selected"
    }
  }

  if (window.innerWidth > 575) {
    confOptions = document.querySelectorAll(selectors.option);

    if (confSettingsOptions.hidden_options) {
      hiddenOptions(confOptions)
    }
    changeOptions(confOptions)
  } else {
    const interval = setInterval(() => {
      confOptions = document.querySelectorAll(selectors.option);

      if (confOptions) {
        clearInterval(interval);

        
        if (confSettingsOptions.hidden_options) {
          hiddenOptions(confOptions)
        }
        changeOptions(confOptions)
      }
    }, 1000);
  }

  function hiddenOptions(options) {
    if (options && confSettingsOptions) {
      options.forEach((option) => {      
        let optionTitle = option.querySelector(selectors.title);

        confSettingsOptions.hidden_options.forEach((hidden) => {
          if (optionTitle.textContent == hidden) {
            option.classList.add('option_none')
          }
        })     
      })
    }
  }

  function changeOptions(options) {
    if (options && confSettingsOptions) {
      let optionHide = [];

      options.forEach((option) => {      
        let optionTitle = option.querySelector(selectors.title);
        if (!optionTitle) return;   
        let optionTitleText = optionTitle.textContent; 
        
        confSettingsOptions.hide.forEach((item) => {
          if (optionTitleText == item) {  
            optionHide.push(option);
          }
        })     
      }) 
            
      options.forEach((option) => {
        let optionTitle = option.querySelector(selectors.title).textContent;
        let optionList = option.querySelectorAll(selectors.option_item);
        

        if (optionTitle == confSettingsOptions.customize.label) {          
          
          optionList.forEach((item) => {
            const title = item.querySelector(selectors.value_title);
            const selectedClass = selectors.value_selected;

            changeStatus();            

            item.addEventListener('click', () => {
              changeStatus();              
            })

            function changeStatus() {
              confSettingsOptions.customize.options.forEach((value) => {      
                if (item.classList.contains(selectedClass) && value.name.toLowerCase() == title.textContent.toLowerCase() && value.visibility == 'hide') {                  
                  optionHide.forEach((hideItem) => {  
                    hideItem.classList.add('option_none');
                  })
                } else if (item.classList.contains(selectedClass) && value.name.toLowerCase() == title.textContent.toLowerCase() && value.visibility == 'show') {                  
                  optionHide.forEach((hideItem) => {
                    if (hideItem.classList.contains('option_none')) {                  
                      hideItem.classList.remove('option_none');
                    }
                  })
                }       
              }) 
            }                   
          })        
        }
      })
    }
  }
});